import { isScopeOnProxy } from '@pubstack/common/src/pbs/pbs-test-bidder'
import { FunctionComponent } from 'react'
import { useAdminScope } from '~/api/admin/admin-scope.api'
import { useAdminScopeTestBidder, useUpdateAdminScopeTestBidder } from '~/api/admin/pbs-scope-config.api'
import { PureAdminScopeTestBidder } from './PureAdminScopeTestBidder'

type Props = { scopeId: string }

export const AdminScopeTestBidder: FunctionComponent<Props> = ({ scopeId }) => {
  const { data: scope } = useAdminScope(scopeId)
  const { data: testBidder } = useAdminScopeTestBidder(scopeId)
  const { mutateAsync: update, isPending } = useUpdateAdminScopeTestBidder(scopeId, {
    successToast: 'Server-side test bidder was successfully updated',
    errorToast: 'Something went wrong when trying to update the server-side test bidder',
  })

  return (
    <PureAdminScopeTestBidder
      testBidder={testBidder}
      isAvailable={!!scope && isScopeOnProxy({ onboardedFeatures: scope.onboardedFeatures, userAccessFeatures: scope.userAccessFeatures })}
      isSaving={isPending}
      onSave={(body) => update(body)}
    />
  )
}
